export default async function sleep(timeInMilliSeconds:number | undefined):Promise<void>{
  return new Promise(resolve => {
    setTimeout(() => resolve(), timeInMilliSeconds ?? 0)
  })
}
